@defer (when asset() && setpointDateRange()) {
  <app-dialog [header]="asset().title" (onClose)="cancel()" [canScroll]="true">
    <app-explorer-asset [asset]="asset()" [site]="site" [setpointQueryDateRange]="setpointDateRange()" [alwaysUseCustom]="true" />
  </app-dialog>
} @placeholder {
  <i class="mdi mdi-loading mdi-spin-x2"></i>
}
